import { ChangeDetectionStrategy, Component, ComponentRef, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { NICmsNotification } from '../icms-notification.interfaces';

@Component({
    standalone: false,
    selector: 'icms-notification-item',
    templateUrl: 'icms-notification-item.html',
    styleUrls: ['icms-notification-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsNotificationItemComponent implements OnInit, OnDestroy {
    @Input()
    data: NICmsNotification.IData = { title: 'Default notification', type: 'error' };

    componentRef!: ComponentRef<ICmsNotificationItemComponent>;

    private timeout?: number;

    constructor(
        private renderer2: Renderer2,
        private elementRef: ElementRef,
        private timeoutService: TimeoutService
    ) {}

    ngOnInit() {
        if (this.data.duration) {
            this.timeout = this.timeoutService.setTimeout(() => this.close(), this.data.duration);
        }
    }

    ngOnDestroy() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    close(event?: Event) {
        event?.preventDefault(); // closing should not trigger any actions including off click etc
        this.renderer2.addClass(this.elementRef.nativeElement, '_closed');
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeoutService.setTimeout(() => {
            this.componentRef.destroy();
            this.componentRef.changeDetectorRef.detectChanges();
        }, 1000);
    }
}
